import React, { useState } from 'react'
import ListNew from './List';
export default function Main() {
    const [type, setType] = useState("list");

    const handleChange = (type) => {
        setType(type)
    }
    return (
        <>
            {
                type == "list" ?
                    <ListNew handleChange={handleChange} />
                    : ''}
        </>
    )
}
